import React from "react";

const DotsHorizontalIcon = ({ fill = "rgba(112, 112, 112, 1)" }) => (
  <svg width="20" height="20" viewBox="0 0 20 20">
    <circle cx="4" cy="10" r="2" fill={fill} />
    <circle cx="10" cy="10" r="2" fill={fill} />
    <circle cx="16" cy="10" r="2" fill={fill} />
  </svg>
);

export default DotsHorizontalIcon;
